module.exports = {
      id: "ribbon-usage",
      viewBox: "0 0 35 38",
      url: "img/" + "sprite.svg#ribbon-usage",
      toString: function () {
        return this.url;
      }
    }